export const validateHandPhoneNumber = (value: string): boolean => {
  if (value === '') return true;
  if (value.length <= 8) {
    return /[89]\d{7}/g.test(value);
  }

  return /\+(65)[89]\d{7}$/g.test(value);
};
